import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(3),
    width: '100%',
    overflowX: 'auto',
  },
  title: {
    margin: theme.spacing(2),
  },
  customInput: {
    '& .MuiOutlinedInput-adornedStart': {
      paddingLeft: '8px', // ปรับ padding-left เป็น 8px
    },
    '& .MuiOutlinedInput-root': {
      transition: 'box-shadow 0.3s ease-in-out',
      '& fieldset': {
        borderWidth: '1px', // กำหนดขนาดเส้นขอบเป็น 1px
      },
      '&:hover fieldset': {
        borderWidth: '1px', // ให้ขนาดขอบคงที่ตอน hover
        borderColor: '#1565c0', // เปลี่ยนสีขอบให้เข้ากับเงา
      },
      '&.Mui-focused fieldset': {
        borderWidth: '1px', // ให้ขนาดขอบคงที่ตอน focus
        borderColor: '#1565c0', // เปลี่ยนสีขอบให้เข้ากับเงา
      },
      '&.Mui-focused': {
        boxShadow: '0 0 8px rgba(33, 150, 243, 0.6)', // สีฟุ้งตอน focus
        backgroundColor: '#fafafa',
      },
    },
    marginTop: '4px',
    marginBottom: '8px',
  },
}));

export default useStyles;
